
import {
    IColumn
} from '@fluentui/react';
import { Stack } from '@fluentui/react/lib/Stack';
import { RootState } from 'app/store';
import { EControlType } from 'components/ControlWrapper';
import { IGridItem } from 'components/controls/CustomDetailList/IGridItem';
import { onRenderColumnFAM } from 'components/controls/Grid';
import * as IXrmTypes from 'model/CRM';
import * as FAM from 'model/FlexibleAttributeModel';
import { useMemo, useState } from 'react';
import { ConnectedProps, connect, useDispatch } from 'react-redux';
import { nonStandardPredicate } from "../../global/Application";


interface IProps extends TComponentConnectedProps {
    groupConfiguration?: FAM.IGroupConfigurationData;
    benefit?: FAM.IBenefit;
    section?: IXrmTypes.bcbs_config_section;
    disabled?: boolean;
    nonStandards?: FAM.INonStandard[];
    variant?: 'importer' | 'default'
}

type TNonStandardGridItem = IGridItem<FAM.INonStandard>;

const NonStandardNonGridView = (props: IProps) => {
    const config = props.state.data.config;
    const [nonStandard, setNonStandard] = useState<FAM.INonStandard | null>(null);

    const categoryGroupConfiguration = props.state?.data?.config?.cache?.map_bcbs_config_category_named['Group Configuration'];

    const dispatch = useDispatch();
    const columns = useMemo(() => {
        const columns: IColumn[] = [];

        columns.push({
            key: 'nonStandardName',
            name: 'Name',
            fieldName: 'name',
            isResizable: true,
            minWidth: 140,
            data: { bcbs_viewsortorder: 0 }
        });

        const predicate = nonStandardPredicate({ section: props.section, benefit: props.benefit, groupConfiguration: props.groupConfiguration })

        config?.attributes?.forEach(eachAttribute => {

            if (!eachAttribute.bcbs_nonstandard)
                return;

            const isOk = predicate(eachAttribute);

            if (!isOk)
                return;

            const eachAttributeMaster = props.state.data.config.cache.map_bcbs_config_masterattribute[eachAttribute._bcbs_config_masterattributeid_value!];

            const column: IColumn = {
                key: eachAttribute.bcbs_config_attributeid!,
                name: eachAttribute.bcbs_name!,
                minWidth: eachAttribute.bcbs_viewcolumnwidth ?? (eachAttribute?.bcbs_name?.length ?? 10) * 8,
                fieldName: eachAttribute.bcbs_config_attributeid,
                data: eachAttribute,
                onRender: onRenderColumnFAM(eachAttributeMaster.bcbs_attributetypecode as EControlType),
                isResizable: true
            };

            columns.push(column);
        });

        return columns.sort((a1, a2) => a1.data.bcbs_viewsortorder! - a2.data.bcbs_viewsortorder!);;

    }, []);

    const items = useMemo(() => {
            const items: TNonStandardGridItem[] = [];
            let target: FAM.INonStandard[] = [];

            if (props.groupConfiguration)
                target = props.groupConfiguration.nonStandards;

            if (props.benefit)
                target = props.benefit.nonStandards;

            // externally supplied non standards?
            if (props.nonStandards)
                target = props.nonStandards

            target.forEach((eNonStandard, index) => {

                // skip deactivated records/only show deactivated records if permitted at group config properties level (xnor)
                if (eNonStandard.deactivated !== props.state.data.json.showInActives?.value)
                    return;

                // skip non-standards that are not for my section
                if (props.section)
                    if (eNonStandard.sectionRef?.id !== props.section.bcbs_config_sectionid)
                        return;
                const item: TNonStandardGridItem = {
                    key: eNonStandard.id,
                    name: eNonStandard.name,
                    _index: index,
                    data: eNonStandard
                };

                eNonStandard.fields.forEach(eaField => {
                    const fieldName = eaField.configRef.id;
                    // lets always get the first one
                    // verified with William there will never be a Tier/PCP/Specialist mode for these.
                    const field = eaField.values[0];
                    item[fieldName] = field.value;
                });

                items.push(item);
            });

            return items;
        },
        [
            props.groupConfiguration?.nonStandards,
            props.benefit?.nonStandards,
            props.nonStandards,
            props.state?.data?.json?.showInActives?.value
        ]
    );

    const onRenderNotGrid = () => {
        return items.map(item => {
                return <div key={item.id}>
                    <Stack horizontal tokens={{
                        childrenGap: 'm', padding: 'm'
                    }}> <Stack.Item><h4>{item.name}</h4></Stack.Item>
<Stack.Item>
                    {item.data?.fields?.map(f => {
                        return <Stack horizontal tokens={{
                            childrenGap: 'm',
                        }}><div style={{fontWeight: 'bold'}}>{f.name}</div>
                            <div>{
                            f.values.map(v => {
                                if(v.value?.type === 'bool')
                                    return v.value.value ? 'Yes' : 'No'

                                //@ts-ignore
                                return v.value?.value ?? v.value?.name ?? 'No Value for Field'
                            })
                        }</div></Stack>
                    })}</Stack.Item></Stack></div>;
        });
    }

    const onRenderComponent = () => {

        return <div>


                {onRenderNotGrid()}

        </div>
    }


    return onRenderComponent();
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(NonStandardNonGridView);
